import { TranslationObject } from '@ngx-translate/core';
import { AspectTypeEnum } from '@lib.core/entities/indicator-type/indicator-type-enum';
import { AspectMetadata } from '@lib.core/entities/indicator/aspect-metadata';

import { ContextMetadataDTO } from '@lib.resources/indicator/dtos/context-metadata';

export class AspectMetadataDTO {
  aspectNameid!: string;
  type!: AspectTypeEnum;
  description!: TranslationObject;
  contextMetaData!: ContextMetadataDTO;

  static toAspectMetadata(aspectMetadataDTO: AspectMetadataDTO): AspectMetadata {
    const { aspectNameid, type, description, contextMetaData } = aspectMetadataDTO;
    const contextMetadataEntity = ContextMetadataDTO.toContextMetadata(contextMetaData);
    return new AspectMetadata(aspectNameid, type, description, contextMetadataEntity);
  }
}
